import { useNavigate } from 'react-router-dom';
import { ADRES_USTAWIEN_ALERTOW, useSettingsLinkState } from '@/lib/settingsModal';

/**
 * Dzwonek alertów w panelu filtrów (Maciek 20.10): zamyka panel jak × (niezatwierdzony szkic
 * przepada, bo każde otwarcie zaczyna szkic od bieżących filtrów) i otwiera Ustawienia na bloku
 * alertów, `/settings?section=notifications#flat-alerts`. Na telefonie Ustawienia wchodzą
 * nakładką nad wyszukiwarką (`backgroundLocation`), na pulpicie to zwykła strona.
 */
export function useOtworzUstawieniaAlertow(zamknijPanel: () => void): () => void {
  const nawiguj = useNavigate();
  const stan = useSettingsLinkState();
  return () => {
    zamknijPanel();
    nawiguj(ADRES_USTAWIEN_ALERTOW, { state: stan });
  };
}
